<script>
  import DropDown from '../components/DropDown.svelte';
  import GridSearch from '../components/GridSearch.svelte';
  import TaskReportModal from 'components/TaskLibrary/TaskReportModal.svelte';
  import AddTaskTempleteModal from '../components/AddTaskTemplateModal.svelte';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import {
    dashboardData,
    getDashboardData,
    setDashboardData,
    resetDashboardData,
  } from '../stores/dashboard.js';
  import { onDestroy, onMount } from 'svelte';
  import DataTable from '../components/DataTable/DataTable.svelte';
  import { client } from 'root/api/index.js';
  import { getContext, setContext } from 'svelte';
  import {
    searchKeyByValue,
    getHashUrlParam,
    cloneArray,
    configItem,
    getValueBySearchValue,
  } from 'components/Helper.js';
  import { authStore, getUserInfo } from '../stores/auth';
  import { Popover } from 'bootstrap';
  const showDialog = getContext('showDialog');
  import { navigate } from 'svelte-routing';

  let taskTemplateModal;
  let taskReportModal;
  let datatableRef;
  let scrollRef;
  let checkBoxSelected = false;
  let recurringTypeList = [];

  const handleCheckbox = (e) => {
    checkBoxSelected = e.target.checked;
    if (checkBoxSelected) {
      selectedTasks = datatableRef.getValues().map((item) => {
        return { id: item.id };
      });
    } else {
      selectedTasks = [];
    }
  };

  let userRolesIndex = null;
  let columns = [];
  let userRoleId = getUserInfo().roleId;
  let taskRiskRankType = configItem.riskRank;

  let defaultFilter = {
    searchKeyword: '',
    taskType: '',
    taskSubType: 1,
    unitProjectTypeId: '',
    responsibleParty: '',
    unitClientTypeId: '',
    unitClientSubTypeId: '',
    unitRegistrationTypeId: '',
    unitRegistrationSubTypeId: '',
    recurringType: '',
    unitProjectId: null,
    units: [],
    priority: [],
    taskActivityTypes: [],
    taskRiskRankType: [],
    taskServiceType: [],
  };

  let extraFilter = { ...defaultFilter };
  let getData = (queries) => {
    return client.taskTemplateList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      el.remove();
    });
    var elements = document.querySelectorAll('.clone_popup');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  let responsibleType = [
    { id: 1, text: 'Us' },
    { id: 2, text: 'Client' },
  ];

  let taskType = [
    { id: 1, text: 'Client' },
    { id: 2, text: 'Internal' },
  ];

  let projects = [];
  let taskActivityTypes = [];
  let taskServiceType = [];
  let clientTypes = [];
  let projectTypes = [];
  let registrationTypes = [];
  let clientSubArr = {};
  let registrationSubArr = {};

  const getUnitDetail = async () => {
    let unitIds = [...extraFilter.units];
    unitIds.map((item) => {
      item.unitId = item.id;
      return item;
    });
    client.taskTemplateFilter({ units: unitIds }).then((response) => {
      projects = response.data.internalProjects;
      taskActivityTypes = [{ id: -1, name: 'No Type' }, ...response.data.taskActivityTypes];
      clientTypes = response.data.clientTypes;
      projectTypes = response.data.projectTypes;
      registrationTypes = response.data.registrationTypes;
      response.data.clientTypes.forEach((value) => {
        clientSubArr[value.id] = value.subClientTypes;
      });
      response.data.registrationTypes.forEach((value) => {
        registrationSubArr[value.id] = value.subRegistrationTypes;
      });
    });
    if (unitIds.length > 0) {
      const result = await client.sowServiceType({ units: unitIds });
      taskServiceType = result?.data?.payload || [];
    }
  };

  let businessUnits = [];
  let taskTypeOptions = [];
  let showImportButton = false;
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        businessUnits = cloneArray(getMasterData().units);
        taskTypeOptions = getMasterData().taskType;
        userRolesIndex = getMasterData().userRoleId;
        let custom = {
          id: -1,
          name: 'As occurs',
        };
        recurringTypeList = state.recurringTypeLabel;
        recurringTypeList = [custom, ...recurringTypeList];

        showImportButton =
          userRolesIndex.unit_admin == userRoleId || userRolesIndex.admin == userRoleId;
        setColumnsHeading();
      }
    });
  });

  const setColumnsHeading = () => {
    let firstColumn = [];
    // if(userRolesIndex != null && userRolesIndex.manager == userRoleId){
    //     firstColumn.push( { key: "id", label: "", sortable: false});
    // }else{
    firstColumn.push({
      key: 'id',
      label: 'Id',
      sortable: true,
      checked: true,
      handleCheckbox: handleCheckbox,
    });
    // }
    let restColumns = [
      {
        key: 'priority',
        label: 'Priority',
        sortable: true,
        checked: true,
        width: 20,
      },
      { key: 'name', label: 'Task', sortable: true },
      { key: 'purpose', label: 'Purpose', sortable: true },
      { key: 'requirement', label: 'Requirement', sortable: true },
      {
        key: 'responsibleParty',
        label: 'Responsible Party',
        sortable: true,
      },
      { key: 'recurring', label: 'Is Recurring', sortable: true },
    ];
    if (businessUnits.length > 1) {
      restColumns = [...restColumns, { key: 'unitName', label: 'Business Unit', sortable: true }];
    }
    restColumns = [
      ...restColumns,
      { key: 'recurringType', label: 'Frequency', sortable: true },
      { key: 'clientCount', label: 'Report', sortable: false },
      // Risk rank column
      { key: 'riskRank', label: 'Risk Rank', sortable: true, checked: true, width: 30 },
      { key: 'active', label: 'Status', sortable: true },
      { key: 'id', label: '', sortable: false },
    ];

    columns = firstColumn.concat(restColumns);
  };

  const dashboardUnsubscribe = dashboardData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined && businessUnits) {
        businessUnits = businessUnits.map((item) => {
          item.checked = searchKeyByValue(state.units, 'id', item.id) != -1;
          return item;
        });
        if (businessUnits.filter((item) => item.checked).length > 0) {
          extraFilter = {
            ...extraFilter,
            units: businessUnits.filter((item) => item.checked),
          };
          getUnitDetail();
        }
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
    dashboardUnsubscribe();
  });

  const addTaskTemplate = () => {
    taskTempleteModal.show();
  };
  const editTaskTemplate = (taskTemplateId) => {
    taskTempleteModal.show(taskTemplateId);
  };

  let searchTimeout;
  let firstTimeLoad = true;
  let searchCloneTimeout;

  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    if (searchCloneTimeout != undefined) {
      clearTimeout(searchCloneTimeout);
    }

    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        if (firstTimeLoad) {
          firstTimeLoad = false;
          searchCloneTimeout = setTimeout(() => {
            initPopupOver();
          }, 400);
          return false;
        }

        if (extraFilter.taskType == taskTypeOptions.project) {
          let allColumns = [...columns];
          columns = allColumns.filter((item) => item.key !== 'responsibleParty');
        } else {
          setColumnsHeading();
        }
        selectedTasks = [];
        datatableRef.initializeState();
        searchCloneTimeout = setTimeout(() => {
          initPopupOver();
        }, 400);
      }
    }, 250);
  };
  $: extraFilter && filterData();

  setContext('taskAction', (params) => {
    if (params.type == 'saveTaskTemplate') {
      filterData();
      selectedTasks = [];
    }
    if (taskTempleteModal != undefined) {
      taskTempleteModal.hide();
    }
  });

  const setClientSubTypes = (id) => {
    let arr = [];
    if (clientSubArr[id] != undefined) {
      arr = clientSubArr[id];
    }
    return arr;
  };
  const setRegistrationSubTypes = (id) => {
    let arr = [];
    if (registrationSubArr[id] != undefined) {
      arr = registrationSubArr[id];
    }
    return arr;
  };

  let selectedTasks = [];
  let clientDropdownRef;
  let registrationDropdownRef;
  let taskTempleteModal;

  const checkUrl = () => {
    setTimeout(() => {
      let params = getHashUrlParam();
      if (params.action != undefined) {
        if (params.action == 'editTaskTemplate') {
          editTaskTemplate(params.taskTemplateId);
        }
        window.location.hash = '';
      }
    }, 1000);
  };

  onMount(() => {
    checkUrl();
  });

  import { downloadCsvFile } from 'components/Helper.js';
  const downloadCsv = () => {
    let filterDataCsv = { ...extraFilter };
    client
      .exportTaskTemplateList({
        ...filterDataCsv,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'task-templates.csv');
      });
  };
  const downloadLikeImportCsv = () => {
    let filterDataCsv = { ...extraFilter };
    client
      .exportLikeImportTaskTemplateList({
        ...filterDataCsv,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'task-templates.csv');
      });
  };

  let assignmentMethod = [
    { id: 1, text: 'Ongoing' },
    { id: 2, text: 'Project' },
    { id: 3, text: 'Ongoing & Project' },
  ];
  const getTypeName = (typeId) => {
    if (typeId > 0) {
      return assignmentMethod[searchKeyByValue(assignmentMethod, 'id', typeId)].text;
    } else {
      return 'Engagement type';
    }
  };

  let updatedIds = [];
  let getCount = () => {
    let queries = {};
    client
      .taskTemplateList(50, 1, {
        ...queries,
        ...extraFilter,
        isTotalCount: 1,
        ids: datatableRef
          .getValues()
          .filter((item) => {
            return updatedIds.indexOf(item.id) == -1;
          })
          .map((item) => item.id),
      })
      .then((result) => {
        for (var i in result.valueArray) {
          // updatedIds.push(result.valueArray[i].id)
          datatableRef.changeData(
            {
              id: result.valueArray[i].id,
              clientCount: result.valueArray[i].clientCount,
              subTaskTemplateCount: result.valueArray[i].subTaskTemplateCount,
            },
            'id',
          );
        }
      });
  };

  let configPriority = cloneArray(configItem.priority);
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-4">
        <h2 class="page-title">Task Library</h2>
      </div>
      <div class="col-md-3">
        <div class="dropdown btn-drop-down">
          <DropDown
            checkbox={true}
            active={true}
            title="Business Unit"
            labelFields="name"
            keyFields="id"
            option={businessUnits}
            checkedFields="checked"
            Style="select-block font-size-13 w-100"
            on:onSelect={(event) => {
              let oldExtraFilter = { ...extraFilter };
              let loadUnit = false;
              if (JSON.stringify(oldExtraFilter.units) != JSON.stringify(event.detail)) {
                oldExtraFilter.units = [...event.detail];
                loadUnit = true;
                taskServiceType = [];
                oldExtraFilter.taskServiceType = [];
              }

              if (oldExtraFilter.units.length == 0) {
                oldExtraFilter = {
                  ...oldExtraFilter,
                  taskType: '',
                  responsibleParty: '',
                  unitClientTypeId: '',
                  unitClientSubTypeId: '',
                  unitRegistrationTypeId: '',
                  unitRegistrationSubTypeId: '',
                  unitProjectId: null,
                };
              }

              extraFilter = { ...oldExtraFilter };
              if (loadUnit) {
                getUnitDetail();
              }
              setDashboardData({
                ...getDashboardData(),
                units: event.detail,
                taskServiceType: [],
                taskActivityTypes: [],
              });
            }}
          />
        </div>
      </div>
      <div class="col-md-5 text-end">
        {#if showImportButton}
          <!-- <button on:click={()=>navigate('/tasklibrary/import-activity-type')} type="button"  class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"><img class="me-2  icon-16" src="./images/import-icon.svg" alt="">Activity Type Update</button> -->
          <button
            on:click={() => navigate('/tasklibrary/import')}
            type="button"
            class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"
            ><img
              class="me-2 icon-16"
              src="./images/import-icon.svg"
              alt=""
            />Import Template</button
          >
        {/if}
      </div>
    </div>
  </div>
  <div class="page-content card-content bg-white">
    <div class="d-flex flex-column h-100">
      <div class="filter-content top-menu-filter">
        <div class="d-flex flex-row mb-0 justify-content-between">
          <div class="">
            <button
              type="button"
              on:click={() => addTaskTemplate()}
              class="mb-0 px-3 font-size-13 add-task-btn"
            >
              + Add Task Template</button
            >

            {#if selectedTasks.length > 0}
              <button
                type="button"
                on:click={() => {
                  showDialog({
                    isDeleteModel: true,
                    type: 'confirm',
                    isTopHeading: 'N',
                    title: '',
                    message:
                      'Are you sure you want to delete the selected template(s). Doing so will soft delete these templates and you will not be able to use or recover these.',
                    okFunc: () => {
                      client
                        .taskTemplateDelete({
                          taskTemplates: selectedTasks,
                          reason: 'Delete',
                        })
                        .then(async (result) => {
                          selectedTasks = [];
                          filterData();
                        })
                        .catch((err) => {
                          showDialog({
                            message: [err.message],
                          });
                        });
                    },
                  });
                }}
                class="mb-0 px-3 font-size-13 add-task-btn mx-1">Delete Selected</button
              >
            {/if}
          </div>
          <div class="d-flex">
            <GridSearch
              bind:value={extraFilter.searchKeyword}
              btnExport={true}
              selectedTasks={selectedTasks}
              placeholder="search task"
              onAction={(params) => {
                if (params == 'export') {
                  downloadLikeImportCsv();
                }
              }}
            />

            <button
              on:click={() => {
                downloadCsv();
              }}
              style="width:100px;"
              class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
            >
              <svg
                class="me-1 icon-16"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background:new 0 0 512 512;"
                xml:space="preserve"
                ><g
                  ><g
                    ><path
                      d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                    /></g
                  ></g
                ><g
                  ><g
                    ><path
                      d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                    /></g
                  ></g
                ></svg
              >

              Old Export</button
            >
          </div>
        </div>

        <div class="d-flex flex-row align-items-center mt-2">
          <DropDown
            checkbox={true}
            deleteSelected={true}
            titleChanged={false}
            active={true}
            title="Priority"
            checkedFields="checked"
            removeIcon={true}
            on:onClear={(event) => {
              extraFilter.priority = [];
            }}
            on:onSelect={(item) => {
              extraFilter.priority = item.detail;
            }}
            option={configPriority}
            Style="select-block"
          />

          <!-- Risk Rank filter -->
          <DropDown
            checkbox={true}
            deleteSelected={true}
            titleChanged={false}
            active={true}
            title="Risk Rank"
            checkedFields="checked"
            removeIcon={true}
            on:onClear={() => {
              extraFilter.taskRiskRankType = [];
            }}
            on:onSelect={(item) => {
              extraFilter.taskRiskRankType = item.detail;
            }}
            option={taskRiskRankType}
            Style="select-block"
          />

          <!-- Service type filter -->
          {#if taskServiceType.length > 0 && extraFilter?.units?.length > 0}
            <DropDown
              searchbox={true}
              checkbox={true}
              deleteSelected={true}
              titleChanged={false}
              title="Service Type"
              checkedFields="checked"
              removeIcon={true}
              option={taskServiceType}
              Style="select-block"
              on:onClear={() => {
                extraFilter.taskServiceType = [];
              }}
              on:onSelect={(item) => {
                extraFilter.taskServiceType = item.detail;
              }}
            />
          {/if}

          {#if extraFilter.units.length > 0}
            <DropDown
              checkbox={true}
              deleteSelected={true}
              titleChanged={false}
              searchbox={true}
              active={true}
              title="Activity Type"
              checkedFields="checked"
              removeIcon={true}
              on:onClear={(event) => {
                extraFilter.taskActivityTypes = [];
              }}
              on:onSelect={(item) => {
                extraFilter.taskActivityTypes = item.detail;
              }}
              option={taskActivityTypes}
              Style="select-block"
            />
          {/if}
          <DropDown
            title={extraFilter.taskType == ''
              ? 'Select task type'
              : taskType[extraFilter.taskType - 1].text}
            on:onSelect={(event) => {
              extraFilter.taskType = event.detail != '' ? event.detail.id : '';
            }}
            option={taskType}
            Style="select-block"
            titleChanged={true}
          />

          {#if extraFilter.units.length > 0}
            {#if extraFilter.taskType == taskTypeOptions.client}
              <div class="dropdown btn-drop-down">
                <DropDown
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  title={getTypeName(extraFilter.taskSubType)}
                  option={assignmentMethod}
                  Style="select-block font-size-13 w-100"
                  titleChanged={true}
                  on:onSelect={(ev) => {
                    extraFilter.taskSubType = ev.detail.id;
                    // toggleFilter()
                  }}
                />
              </div>
              {#if extraFilter.taskSubType == 2 || extraFilter.taskSubType == 3}
                <DropDown
                  title="Select Project type"
                  searchbox={true}
                  option={projectTypes}
                  Style="select-block"
                  titleChanged={true}
                  on:onSelect={(event) => {
                    extraFilter.unitProjectTypeId = event.detail.id;
                  }}
                />
              {/if}
              {#if extraFilter.taskSubType == 1 || extraFilter.taskSubType == 3}
                <DropDown
                  title="Select Client type"
                  searchbox={true}
                  option={clientTypes}
                  Style="select-block"
                  titleChanged={true}
                  on:onSelect={(event) => {
                    extraFilter.unitClientTypeId = event.detail.id;
                    extraFilter.unitClientSubTypeId = '';
                    clientDropdownRef.resetSelectBox();
                  }}
                />

                <DropDown
                  title="Select Client sub type"
                  option={setClientSubTypes(extraFilter.unitClientTypeId)}
                  Style="select-block"
                  titleChanged={true}
                  bind:this={clientDropdownRef}
                  on:onSelect={(event) => {
                    extraFilter.unitClientSubTypeId = event.detail.id;
                  }}
                />

                <DropDown
                  searchbox={true}
                  title="Select Registration type"
                  option={registrationTypes}
                  Style="select-block"
                  titleChanged={true}
                  on:onSelect={(event) => {
                    extraFilter.unitRegistrationTypeId = event.detail.id;
                    extraFilter.unitRegistrationSubTypeId = '';
                    registrationDropdownRef.resetSelectBox();
                  }}
                />

                <DropDown
                  title="Select Registration sub type"
                  option={setRegistrationSubTypes(extraFilter.unitRegistrationTypeId)}
                  Style="select-block"
                  titleChanged={true}
                  bind:this={registrationDropdownRef}
                  on:onSelect={(event) => {
                    extraFilter.unitRegistrationSubTypeId = event.detail.id;
                  }}
                />
              {/if}
            {/if}

            {#if extraFilter.taskType == taskTypeOptions.project}
              <DropDown
                title="All Project"
                searchbox={true}
                option={projects}
                Style="select-block"
                titleChanged={true}
                on:onSelect={(event) => {
                  extraFilter.unitProjectId = event.detail.id;
                }}
              />
            {/if}
          {/if}

          {#if extraFilter.taskType == taskTypeOptions.client}
            <DropDown
              title={extraFilter.responsibleParty == ''
                ? 'Select Responsible'
                : responsibleType[extraFilter.responsibleParty - 1].text}
              option={responsibleType}
              Style="select-block"
              titleChanged={true}
              on:onSelect={(event) => {
                extraFilter.responsibleParty = event.detail != '' ? event.detail.id : '';
              }}
            />
          {/if}

          <DropDown
            defaultTitle="Frequency"
            title={extraFilter.recurringType != '' &&
            extraFilter.recurringType > 0 &&
            searchKeyByValue(recurringTypeList, 'id', extraFilter.recurringType) != -1
              ? recurringTypeList[
                  searchKeyByValue(recurringTypeList, 'id', extraFilter.recurringType)
                ].name
              : 'Frequency'}
            option={recurringTypeList}
            Style="select-block"
            titleChanged={true}
            on:onSelect={(event) => {
              extraFilter.recurringType = event.detail.id;
            }}
          />
          {#if extraFilter.taskType != '' || extraFilter.responsibleParty != '' || extraFilter.recurringType != '' || !!extraFilter.taskRiskRankType.length || !!extraFilter?.taskServiceType?.length}
            <button
              type="button"
              class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-1 me-1 bg-transparent border-0"
              on:click={() => {
                extraFilter = {
                  ...defaultFilter,
                  units: extraFilter.units,
                };

                taskActivityTypes = taskActivityTypes.map((item) => {
                  item.checked = false;
                  return item;
                });
                // Reseting the filter
                taskRiskRankType = taskRiskRankType.map((item) => {
                  item.checked = false;
                  return item;
                });

                taskServiceType = taskServiceType.map((item) => {
                  item.checked = false;
                  return item;
                });

                configPriority = cloneArray(configItem.priority);
              }}
            >
              <img
                class="icon-14 me-2"
                alt=""
                src="/images/reset.svg"
              />
              Reset Filter
            </button>
          {/if}
        </div>
      </div>

      <div class="page-content card border-0">
        <div
          class="tab-content d-flex flex-column h-100 p-3"
          id="myTabContent2"
        >
          <div
            class="tab-pane page-content fade show active"
            id="home2"
            role="tabpanel"
            aria-labelledby="home-tab2"
            bind:this={scrollRef}
          >
            <DataTable
              datatableCallback={(state) => {
                getCount();
              }}
              bind:this={datatableRef}
              columns={columns}
              scrollRef={scrollRef}
              getData={getData}
              let:row
            >
              <td
                class="text-muted"
                width="30"
              >
                <!-- {#if userRolesIndex.manager != userRoleId}               -->
                <div class="checkbox c-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="task_template_id"
                      checked={checkBoxSelected}
                      on:change={(event) => {
                        let oldSelectedTasks = selectedTasks;
                        if (event.target.checked) {
                          oldSelectedTasks.push({
                            id: row.id,
                          });
                        } else {
                          oldSelectedTasks.splice(searchKeyByValue(selectedTasks, 'id', row.id), 1);
                        }
                        selectedTasks = oldSelectedTasks;
                      }}
                      value="1"
                    />
                    <span class="check-img"></span>
                  </label>
                </div>
                <!-- {/if} -->
              </td>
              <td
                class="text-muted"
                width="20"
              >
                <DropDown
                  showTitle={true}
                  showIcon={false}
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  titleChanged={true}
                  value={row.priority}
                  extraClass={getValueBySearchValue(
                    configItem.priority,
                    'id',
                    row.priority,
                    'extraClass',
                  )}
                  icon={getValueBySearchValue(configItem.priority, 'id', row.priority, 'icon')}
                  title={getValueBySearchValue(configItem.priority, 'id', row.priority, 'name')}
                  defaultTitle="Priority"
                  on:onSelect={(item) => {
                    client
                      .taskTemplateChangePriority({
                        priority: item.detail.id,
                        taskTemplates: [{ id: row.id }],
                      })
                      .then(async (result) => {
                        if (
                          extraFilter.priority.length > 0 &&
                          extraFilter.priority.filter((iitem) => iitem.id == item.detail.id)
                            .length == 0
                        ) {
                          selectedTasks = [];
                          filterData();
                        }
                        datatableRef.changeData(
                          {
                            id: row.id,
                            priority: item.detail.id,
                          },
                          'id',
                        );
                      });
                  }}
                  option={configItem.priority}
                  Style="select-block priority-dropdown-template"
                />
              </td>
              <td
                class="text-muted"
                width="300"
              >
                <button
                  type="button"
                  class="bg-transparent border-0 p-0 color-blue text-break text-start"
                  on:click={() => {
                    editTaskTemplate(row.id);
                  }}
                >
                  {row.name}
                  {#if row.subTaskTemplateCount > 0}
                    <img
                      alt=""
                      class="icon-14 ms-2 me-1"
                      src="/images/checklist.svg"
                    />
                    <span class="align-middle">{row.subTaskTemplateCount}</span>
                  {/if}
                </button>
              </td>
              <td
                class="text-muted"
                width="300"
              >
                <span class="text-break">{row.purpose}</span>
              </td>
              <td
                class="text-muted"
                width="300"
              >
                <span class="text-break">{row.requirement}</span>
              </td>
              {#if extraFilter.taskType == '' || extraFilter.taskType == taskTypeOptions.client}
                <td class="text-muted">{row.responsiblePartyLabel}</td>
              {/if}

              <td class="text-muted">{row.recurringLabel}</td>
              {#if businessUnits.length > 1}
                <td class="text-muted">{row.unitName}</td>
              {/if}
              <td class="text-muted">{row.recurringTypeLabel}</td>
              <td
                class="text-muted"
                width="80"
              >
                {#if row.clientCount > 0}
                  <button
                    type="button"
                    class="bg-transparent border-0 p-0 color-blue"
                    on:click={() => {
                      taskReportModal.showModal(row.id, row.name);
                    }}
                    >{row.clientCount + ' ' + row.reportText}
                  </button>
                {:else}
                  {row.clientCount + ' ' + row.reportText}
                {/if}
              </td>
              <!-- Risk Rank column -->
              <td
                class="text-muted"
                width="30"
              >
                <DropDown
                  showTitle={true}
                  showIcon={false}
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  titleChanged={true}
                  value={row.riskRank}
                  extraClass={getValueBySearchValue(
                    configItem.riskRank,
                    'id',
                    row.riskRank,
                    'extraClass',
                  )}
                  title={getValueBySearchValue(configItem.riskRank, 'id', row.riskRank, 'name')}
                  defaultTitle="Risk Rank"
                  on:onSelect={(item) => {
                    client
                      .taskTemplateRiskRank({
                        riskRank: item.detail.id,
                        taskTemplates: [{ id: row.id }],
                      })
                      .then(() => {
                        if (
                          !!extraFilter.taskRiskRankType.length &&
                          !extraFilter.taskRiskRankType?.find?.(
                            (fItem) => fItem.id === item.detail.id,
                          )
                        ) {
                          selectedTasks = [];
                          filterData();
                        }
                        datatableRef.changeData(
                          {
                            id: row.id,
                            riskRank: item.detail.id,
                          },
                          'id',
                        );
                      });
                  }}
                  option={configItem.riskRank}
                  Style="select-block risk-rank-dropdown"
                />
              </td>
              <td width="70">
                <div class="form-check form-switch status-switch-block">
                  <input
                    id={row.id}
                    checked={row.active === 1}
                    class="form-check-input shadow-none"
                    type="checkbox"
                    on:change={(event) => {
                      client
                        .taskTemplateUpdateStatus({
                          id: row.id,
                        })
                        .then((result) => {
                          row.active = event.target.checked
                            ? configItem.status.active
                            : configItem.status.inactive;
                        })
                        .catch((error) => {
                          event.target.checked = row.active === configItem.status.active;
                          showDialog({
                            message: error.message,
                          });
                        });
                    }}
                  />
                </div>
              </td>
              <td class="text-muted">
                <button
                  type="button"
                  class="bg-transparent border-0 color-blue clone_popup"
                  data-bs-placement="top"
                  data-bs-toggle="popover"
                  data-bs-trigger="hover focus"
                  data-bs-content="clone"
                  on:click={() => {
                    showDialog({
                      type: 'confirm',
                      title: '',
                      message: 'Are you sure ?',
                      extraMessage: 'Doing this will add a new template to the task library',
                      okFunc: () => {
                        client
                          .taskTemplateClone({
                            id: row.id,
                          })
                          .then((response) => {
                            selectedTasks = [];
                            filterData();

                            setTimeout(() => {
                              editTaskTemplate(response.data.id);
                            }, 300);
                          })
                          .catch((err) => {
                            showDialog({
                              message: err.message,
                            });
                          });
                      },
                    });
                  }}
                  ><img
                    class="icon-16"
                    alt=""
                    src="/images/copy.svg"
                  /></button
                >
              </td>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<TaskReportModal
  bind:this={taskReportModal}
  handleClick={(params) => {}}
/>
<AddTaskTempleteModal bind:this={taskTempleteModal} />
